import { useState, useEffect } from 'react';
import { ElementRead } from '../apiTypes';
import { listElements } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export const useElementDettaglio = (reportId?: string, componentId?: string) => {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [elements, setElements] = useState<ElementRead[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId || !componentId) return;

    const loadElements = async () => {
      setLoading(true);
      try {
        const data = await listElements(reportId, componentId);
        setElements(data);
        setError(null);
      } catch (err) {
        setError('Errore nel caricamento degli elementi');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadElements();
  }, [reportId, componentId]);

  return { elements, loading, error };
};
